import cx from 'classnames';
import React from 'react';
import { DestinationsList } from '../../../../components';
import type { ScheduledEvent } from '../../graphql';
import { EventType } from '../../graphql';

export const Wrapper = (
  props: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
): React.ReactElement => <div className='mt-16px' {...props} />;

// @fixme: Josh- make this use the distributions field on scheduledEvent
export const Stats = ({
  className,
  event,
  production
}: {
  className?: string;
  production?: EventType;
  event: ScheduledEvent;
}): React.ReactElement => (
  <p className={cx('d-flex mb-0px align-items-center', className)}>
    {production === EventType.Produced ? (
      <span>
        <i className='far fa-camera-movie mr-8px' />
        <span className='font-weight-bold'>Produced</span>
      </span>
    ) : production === EventType.SimLive ? (
      <span>
        <i className='far fa-calendar-day mr-8px' />
        <span className='font-weight-bold'>Sim Live</span>
      </span>
    ) : production === EventType.Mobile ? (
      <span>
        <i className='far fa-mobile mr-8px' />
        <span className='font-weight-bold'>Mobile</span>
      </span>
    ) : production === EventType.MobileKit ? (
      <span>
        <i className='far fa-mobile mr-8px' />
        <span className='font-weight-bold'>Mobile Kit</span>
      </span>
    ) : production === EventType.Test ? (
      <span>
        <i className='far fa-broadcast-tower mr-8px' />
        <span className='font-weight-bold'>Test</span>
      </span>
    ) : (
      <span>
        <i className='far fa-camera-home mr-8px' />
        <span className='font-weight-bold'>Static</span>
      </span>
    )}
    <span className='flex-grow-1' />
    <DestinationsList {...event} />
  </p>
);
